import { Array, Boolean, Null, Number, Optional, Record, Static, String } from 'runtypes';

export const FilterBoxesRunType = Record({
	boxId: String.Or(Null),
	isVirtual: Boolean.Or(Null),
	name: String.Or(Null),
});

export type FilterBoxes = Static<typeof FilterBoxesRunType>;

export const FilterUsersRunType = Record({
	UserAvatar: Optional(String),
	UserDisplayname: Optional(String),
	active: Boolean,
	fullName: String,
	groupName: Optional(String),
	userId: Number,
	userIds: Optional(Array(String)),
});

export type FilterUsers = Static<typeof FilterUsersRunType>;

export const FilterModuleRunType = Record({
	internalModuleIdentifier: String,
	label: String,
	moduleIcon: String,
	moduleIdentifier: String,
});

export type FilterModule = Static<typeof FilterModuleRunType>;

// Module mit Filter-Sidebar — gemeinsam genutzt vom Klassik-Layout (MainLayoutLargeDevice)
// und vom Tab-Arbeitsbereich (GenericActivityListTabPanel rendert die Rail dort selbst).
export const FILTER_SUPPORTED_MODULES: ReadonlyArray<string> = [
	'inbox',
	'documentList',
	'filterList',
	'phoneCallList',
	'mailList',
	'messageList',
	'noteList',
	'taskList',
	'trashList',
];
